(function(){
  // Tabs
  const tabs = document.querySelectorAll('.tabs-nav [role="tab"]');
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){ t.setAttribute('aria-selected','false'); });
      document.querySelectorAll('.tab-panel').forEach(function(p){ p.classList.remove('active'); p.hidden = true; });
      tab.setAttribute('aria-selected','true');
      const panel = document.getElementById(tab.getAttribute('aria-controls'));
      panel.classList.add('active');
      panel.hidden = false;
    });
    tab.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' '){ e.preventDefault(); tab.click(); }
    });
  });

  // How-to-use accordion
  document.querySelectorAll('[data-accordion] .accordion-header').forEach(function(btn){
    btn.addEventListener('click', function(){
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      document.getElementById(btn.getAttribute('aria-controls')).classList.toggle('open');
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-question').forEach(function(btn){
    btn.addEventListener('click', function(){
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      btn.nextElementSibling.classList.toggle('open');
    });
  });


})();